'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selectionConstants = require('../../common/elements/selectionConstants');

var _draggingConstants = require('../reducers/draggingConstants');

var _navigationActions = require('../reducers/navigationActions');

var _lodash = require('lodash');

exports.default = function (store) {
    return function (next) {
        return function (action) {
            if (action.remote) return next(action);

            var filterState = (0, _lodash.get)(store.getState().get('routing'), ['locationBeforeTransitions', 'search']);
            if (!filterState) return next(action);

            switch (action.type) {
                case _selectionConstants.ELEMENTS_SELECTED:
                case _selectionConstants.ELEMENT_EDIT_START:
                case _draggingConstants.DRAG_START:
                    store.dispatch((0, _navigationActions.clearFilter)());
                    break;
                default:
                    break;
            }

            return next(action);
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/store/filterStateRoutingMiddleware.js
// module id = 2050
// module chunks = 0